const themeModule = {
	state: {
		theme: window.localStorage.getItem('niko-works-theme') === 'true' || false
	},
	actions: {
		changeTheme({ commit }, theme) {
			commit('changeTheme', theme)
		}
	},
	mutations: {
		changeTheme(state, theme) {
			state.theme = theme
			window.localStorage.setItem('niko-works-theme', theme)
		}
	},
	getters: {
		getTheme(state) {
			return state.theme
		}
	}
}

export default themeModule
